import { render, staticRenderFns } from "./KnowledgeWorkspace.vue?vue&type=template&id=50674554&scoped=true"
import script from "./KnowledgeWorkspace.vue?vue&type=script&lang=js"
export * from "./KnowledgeWorkspace.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeWorkspace.vue?vue&type=style&index=0&id=50674554&prod&scoped=true&lang=css"
import style1 from "./KnowledgeWorkspace.vue?vue&type=style&index=1&id=50674554&prod&scoped=true&lang=css"
import style2 from "./KnowledgeWorkspace.vue?vue&type=style&index=2&id=50674554&prod&scoped=true&lang=css"
import style3 from "./KnowledgeWorkspace.vue?vue&type=style&index=3&id=50674554&prod&scoped=true&lang=css"
import style4 from "./KnowledgeWorkspace.vue?vue&type=style&index=4&id=50674554&prod&scoped=true&lang=css"
import style5 from "./KnowledgeWorkspace.vue?vue&type=style&index=5&id=50674554&prod&scoped=true&lang=css"
import style6 from "./KnowledgeWorkspace.vue?vue&type=style&index=6&id=50674554&prod&scoped=true&lang=css"
import style7 from "./KnowledgeWorkspace.vue?vue&type=style&index=7&id=50674554&prod&scoped=true&lang=css"
import style8 from "./KnowledgeWorkspace.vue?vue&type=style&index=8&id=50674554&prod&scoped=true&lang=css"
import style9 from "./KnowledgeWorkspace.vue?vue&type=style&index=9&id=50674554&prod&scoped=true&lang=css"
import style10 from "./KnowledgeWorkspace.vue?vue&type=style&index=10&id=50674554&prod&scoped=true&lang=css"
import style11 from "./KnowledgeWorkspace.vue?vue&type=style&index=11&id=50674554&prod&scoped=true&lang=css"
import style12 from "./KnowledgeWorkspace.vue?vue&type=style&index=12&id=50674554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50674554",
  null
  
)

export default component.exports